export default {
  computed: {
    sizeMinRanges() {
      const result = [];
      for (let i = 4; i <= 29; i += 1) {
        result.push(`${i * 10}`);
      }
      return result;
    },
    sizeMaxRanges() {
      const result = [];
      for (let i = 4; i <= 29; i += 1) {
        result.push(`${(i + 1) * 10}`);
      }
      return result;
    },
  },
};
